import { useEffect, useState } from 'react';
import { WebinarStatus } from '@core/types';
import { HostName, UpNextWebinarCountdown, UpNextWebinarDate, WebinarLiveIndicator } from '../../atoms';
import { DateTime } from 'luxon';
import { getI18n, useTranslation } from 'react-i18next';

interface Props {
    broadcastDateTime: string;
    nameOfHost: string;
    plannedDuration: string;
    startedTime?: string;
    status: WebinarStatus;
}

export const UpNextWebinarInfo = ({ broadcastDateTime, nameOfHost, plannedDuration, startedTime, status }: Props) => {
    const { t } = useTranslation();
    const [now, setNow] = useState(DateTime.now());

    useEffect(() => {
        // Webinars that are not planned or started do not need to be updated
        if (status !== WebinarStatus.Planned && status !== WebinarStatus.Started) return;

        setNow(DateTime.now());
    }, [status]);

    return (
        <>
            <div className="flex flex-wrap items-center gap-x-6 gap-y-4 mb-6">
                <UpNextWebinarDate date={broadcastDateTime} duration={plannedDuration} />
                
                {status === WebinarStatus.Started &&
                    <WebinarLiveIndicator now={now} startedTime={startedTime} status={status} />
                }
                {status === WebinarStatus.Planned &&

                    <UpNextWebinarCountdown broadcastDateTime={broadcastDateTime} now={now} />
                }
            </div>
            <HostName nameOfHost={nameOfHost} />
        </>
    )
};
